import React from 'react'
import Chip from '@mui/material/Chip'
import { Tooltip, Zoom } from '@mui/material'

interface ComponentProps {
  batchState: string
}

const DisbursementInstructionStateChip: React.FC<ComponentProps> = ({ batchState }: ComponentProps) => {
  let variant: 'outlined' | undefined
  let color: 'primary' | 'warning' | 'error' | 'secondary' | 'success' | undefined

  if (['NEW', 'FLAGGED', 'CANCELLED'].includes(batchState)) {
    color = 'error'
    variant = 'outlined'
  } else if (['PENDING', 'CONFIRMED'].includes(batchState)) {
    color = 'primary'
    variant = 'outlined'
  } else if (batchState === 'PROCESSED') {
    color = 'success'
    variant = 'outlined'
  }

  return (
    <>
      <Tooltip title={batchState} TransitionComponent={Zoom} arrow placement="bottom">
        <Chip label={batchState} variant={variant} color={color}/>
      </Tooltip>
    </>
  )
}

export default DisbursementInstructionStateChip
